import { render } from "./Event.vue?vue&type=template&id=0124d163&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=0124d163&lang=scss&scoped=true"
import "./Event.vue?vue&type=style&index=1&id=0124d163&lang=scss"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0124d163"]])

export default __exports__